import { Injectable } from '@angular/core';
import { GenericViewEndUserDto } from '@osos/shared/api';
import { GenericViewPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { PublicGenericViewsParserV1Service } from '../../parsers/public-generic-view-parser/public-generic-view-parser.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class PublicGenericViewsFactoryService extends FactoryBase<
  GenericViewEndUserDto,
  GenericViewPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: PublicGenericViewsParserV1Service,
  ) {
    super(parserFactory);
    parserFactory.register(parser_v1);
  }

  createPresenterModel(
    model: GenericViewEndUserDto,
  ): GenericViewPresenterModel {
    const parser = this.getParser(
      GenericViewEndUserDto,
      GenericViewPresenterModel,
      1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }

  createDataModel(presenter: GenericViewPresenterModel): GenericViewEndUserDto {
    const parser = this.getParser(
      GenericViewEndUserDto,
      GenericViewPresenterModel,
      presenter.specificationVersion || 1,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
}
